<template>
  <div id="">
    <Header />
      <slot />
    <HeaderBottom />
    <!-- <Footer /> -->
  </div>
</template>
<script>
import {mapState} from 'vuex'
import Header from "./sections/Header.vue";
import HeaderBottom from "./sections/HeaderBottom.vue";
// import Footer from "./sections/Footer.vue";
export default{
components:{
  Header,
  // Footer,
  HeaderBottom,
},
computed:{
  ...mapState(['new_connection', 'max_file_upload', 'max_file_size'])
}
}
</script>
<style scoped>
</style>
